var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCertificates(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 16H14.3334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33398 12.6671H14.3334",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2493 19.3329C24.7803 19.3329 26.8321 17.2811 26.8321 14.7501C26.8321 12.2191 24.7803 10.1673 22.2493 10.1673C19.7183 10.1673 17.6665 12.2191 17.6665 14.7501C17.6665 17.2811 19.7183 19.3329 22.2493 19.3329Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3331 21.8327H6.00121C5.78022 21.8327 5.56828 21.7449 5.41202 21.5886C5.25576 21.4324 5.16797 21.2204 5.16797 20.9994V7.66759C5.16797 7.4466 5.25576 7.23466 5.41202 7.0784C5.56828 6.92214 5.78022 6.83435 6.00121 6.83435H24.3325C24.5535 6.83435 24.7654 6.92214 24.9217 7.0784C25.0779 7.23466 25.1657 7.4466 25.1657 7.66759V11.2151",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.333 18.2852V25.1656L22.2493 23.4992L25.1657 25.1656V18.2852",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCertificates);
export default __webpack_public_path__ + "static/media/certificates.28faad1f062314fe4a182cb6b0614171.svg";
export { ForwardRef as ReactComponent };